























import { Component, Vue } from 'vue-property-decorator';
import { Enterprise } from '@/resources/enterprise/Enterprise';
import EnterpriseCard from '@/components/work/EnterpriseCard.vue';
import { ENTERPRISES_REQUEST, GET_ENTERPRISES, GET_STATUS } from '@/store/models/work/enterprises';
import { Getter } from 'vuex-class';
import PublicLayout from '@/views/layouts/PublicLayout.vue';

@Component({
  components: { PublicLayout, EnterpriseCard }
})
export default class Index extends Vue {
  @Getter(GET_ENTERPRISES) enterprises!: Array<Enterprise>;
  @Getter(GET_STATUS) status!:boolean|null;

  created () {
    this.$store.dispatch(ENTERPRISES_REQUEST);
  }

  get loading ():boolean {
    return this.status !== null;
  }
}
